export const transactionTypeDescriptions = {
  currentStock: 'Current Stock for',
  sampleReserve: 'Sample Reserve for',
  unallocatedStock: 'TBD',
  salesOrder: 'Sales Order',
  transferIn: 'Transfer In',
  transferOut: 'Transfer Out',
  purchaseOrder: 'Purchase Order',
};

export const transactionTypeShortDescriptions = {
  currentStock: 'QOH',
  sampleReserve: 'SAMPLE',
  unallocatedStock: 'TBD',
  salesOrder: 'SO',
  transferIn: 'TR-IN',
  transferOut: 'TR-OUT',
  purchaseOrder: 'PO',
};

export const transactionTypes = {
  currentStock: 'currentStock',
  sampleReserve: 'sampleReserve',
  ghostStock: 'ghostStock',
  partialReserve: 'partialReserve',
  futureStock: 'futureStock',
  unallocatedStock: 'unallocatedStock',
  salesOrder: 'salesOrder',
  transferIn: 'transferIn',
  transferOut: 'transferOut',
  purchaseOrder: 'purchaseOrder',
};

export const inboundOrderTypes = [
  transactionTypes.transferIn,
  transactionTypes.purchaseOrder,
];
